import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const mostrarMensaje = (mensaje, icono, timer) => {
  MySwal.fire({
    position: "center",
    icon: icono,
    title: mensaje,
    showConfirmButton: true,
    timer: timer,
    customClass: {
      title: 'my-custom-title-class'
    },
    didOpen: () => {
      const titleElement = document.querySelector('.my-custom-title-class');
      if (titleElement) {
        titleElement.style.fontSize = '21px'; // Tamaño de fuente personalizado
      }
    }
  });
};

export const mostrarMensajeEnPopUp = (mensaje, icono, timer) => {
  MySwal.fire({
    position: "center",
    icon: icono,
    title: mensaje,
    showConfirmButton: true,
    timer: timer,
    customClass: {
      title: 'my-custom-title-class'
    },
    didOpen: () => {
      const titleElement = document.querySelector('.my-custom-title-class');
      if (titleElement) {
        titleElement.style.fontSize = '21px'; // Tamaño de fuente personalizado
      }
    },
    willClose: () => {
      window.close(); // Cierra la ventana cuando se cierra la alerta
    }
  });
};


export const useMostrarMensajeConfirmacion = () => {
  const mostrarMensajeConfirmacion = ( mensaje, funcion, icono ) => {
    MySwal.fire({
      title: "",
      html: mensaje,
      icon: icono,
      showCancelButton: true,
      confirmButtonColor: "#EB0045",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Confirmar",
      customClass: {
        confirmButton: "btn-confirmar-clase",
        cancelButton: "btn-cancelar-clase"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        funcion()    
      }
    });
  };

  return mostrarMensajeConfirmacion;
};